import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxCodeAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7.37498 16.781L8.62498 15.219L4.60098 12L8.62498 8.781L7.37498 7.219L2.37498 11.219C2.25783 11.3127 2.16325 11.4315 2.09825 11.5667C2.03326 11.7019 1.99951 11.85 1.99951 12C1.99951 12.15 2.03326 12.2981 2.09825 12.4333C2.16325 12.5685 2.25783 12.6873 2.37498 12.781L7.37498 16.781ZM16.625 7.219L15.375 8.781L19.399 12L15.375 15.219L16.625 16.781L21.625 12.781C21.7421 12.6873 21.8367 12.5685 21.9017 12.4333C21.9667 12.2981 22.0005 12.15 22.0005 12C22.0005 11.85 21.9667 11.7019 21.9017 11.5667C21.8367 11.4315 21.7421 11.3127 21.625 11.219L16.625 7.219ZM14.976 3.216L10.976 21.216L9.02298 20.782L13.023 2.782L14.976 3.216Z"
	})
});
export default SvgBxCodeAlt;
